import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/login`, {
        email,
        password,
      });

      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("userId", response.data.userId);
        localStorage.setItem("clientEmail", response.data.email);

        // Show modal on success
        setShowModal(true);
      } else {
        setError(response.data.message || "Login failed. Please try again.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Server error. Please try again later.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row items-start justify-center min-h-screen bg-gray-100 p-8 bg-cover bg-center"
      style={{
        backgroundImage: "url('/assets/img/bg-3.jpg')",
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}>
        
      <div className="flex flex-col items-center mb-10 md:mb-0 md:mr-10">
        <img
          src="/assets/img/oneHub_logo1.png"
          alt="Logo"
          className="w-32 h-32 mb-4 rounded-full shadow-lg"></img>
        <h1 className="text-4xl font-bold text-center bg-white px-4 py-2 rounded shadow">
          <span className="bg-black text-gray-100 px-2 rounded">One</span> Crm
        </h1>
        <h2 className="text-center text-5xl font-bold mb-4">Client Page</h2>
      </div>


      <div className="max-w-sm bg-white p-6 rounded-lg shadow-md mx-auto md:mx-0 mt-12 md:mt-12 md:-ml-6">


        <h1 className="text-center text-2xl font-bold mb-4">Login</h1>
        {error && <div className="bg-red-200 text-red-800 px-4 py-2 rounded mb-4">{error}</div>}

        <form onSubmit={handleSubmit}>
          <label className="block mb-2 font-semibold">Email</label>
          <input
            type="email"
            placeholder="Enter your email"
            className="w-full px-3 py-2 border rounded mb-4"
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label className="block mb-2 font-semibold">Password</label>
          <div className="relative mb-4">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              className="w-full px-3 py-2 border rounded pr-10"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-2 top-2 text-gray-600"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <button type="submit" className="w-full bg-black text-white py-2 rounded">
            Login
          </button>
        </form>

        <p className="text-center mt-2 text-sm">
          <Link to="/forgot-password" className="text-black underline">
            Forgot Password?
          </Link>
        </p>
        <p className="text-center mt-2 text-sm">Don't have an account?</p>
        <Link to="/SignUp" className="block text-center bg-black text-white py-2 rounded mt-2">
          Register
        </Link>
      </div>


      {/* Modal on successful login */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-xl">
            <h3 className="text-xl font-bold mb-4 text-green-600">Login Successful</h3>
            <p className="mb-6">Do you want to go to the home page?</p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={() => navigate("/Home")}
                className="px-4 py-2 bg-black text-white rounded hover:bg-gray-800"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;
